module.exports = __webpack_public_path__ + "img/bg_教学互动.094bd464.png";